import { useEffect, useState } from 'react';
import { accountsApi } from '../api/accounts';
import type { AccountDto } from '../types/account';

/**
 * Shared account dropdown for the report screens (kasos knyga, sąskaitų
 * išrašas, suderinimo aktas). Loads the chart once per mount; the accountant
 * picks by number-name pair. No free-text entry — the chart of accounts is
 * closed data.
 */
export default function AccountSelect({
  value,
  onChange,
  className,
}: {
  value: number | null;
  onChange: (account: number | null) => void;
  className?: string;
}) {
  const [accounts, setAccounts] = useState<AccountDto[]>([]);

  useEffect(() => {
    let cancelled = false;
    accountsApi
      .list({ limit: 500 })
      .then(list => {
        if (!cancelled) setAccounts(list);
      })
      .catch(() => {
        // Keep the dropdown empty — the request error surfaces on Generate.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <select
      className={className}
      value={value ?? ''}
      onChange={e => onChange(e.target.value ? Number(e.target.value) : null)}
    >
      <option value="">— sąskaita —</option>
      {accounts.map(a => (
        <option key={a.accountNumber} value={a.accountNumber}>
          {a.accountNumber} — {a.name}
        </option>
      ))}
    </select>
  );
}
